import React from 'react';

interface Props {
  label: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  helpText?: string;
}

const FormField: React.FC<Props> = ({ label, error, required = false, children, helpText }) => {
  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-surface-700">
        {label}
        {required && <span className="ml-0.5 text-danger-500">*</span>}
      </label>
      {children}
      {helpText && !error && (
        <p className="text-xs text-surface-400">{helpText}</p>
      )}
      {error && (
        <p className="text-xs text-danger-500" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
